module.exports = __webpack_public_path__ + "static/media/project_frontlineAirsoft.4d26320b.png";